import React from "react";
import styles from "./FieldWithIcon.module.css";

interface FieldWithIconProps {
    imageUrl: string;
    fieldValue: string;
}

export const FieldWithIcon: React.FC<FieldWithIconProps> = ({imageUrl, fieldValue}) => {
    return (
        <span className={styles.wrapper}>
            <img
                src={imageUrl}
                alt={fieldValue}
                className={styles.icon}
            />
            <span className={styles.text}>{fieldValue}</span>
        </span>
    );
};
